import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { checkPrivileges } from "../../Helpers";
import useIdentityForm from "../identity/useIdentityForm";
import { computeCreateFieldErrors } from "../identity/validation";
import AddAccountModal from "./addAccount";
import {
  countDevices,
  countUsers,
  countVehicles,
  createIdentity,
  handleIdentityError,
  listAccountManagers,
  listAccountsForPicker,
  listCompanies,
  listGarages,
  listParentUsers,
  listVehicles,
} from "./accountsApi";

const CreateUpdateForm = ({ translate, onCancel, onCreated }) => {
  const logInUser = useSelector((state) => state.logInUsers);
  const roles = useSelector((state) => state.roles);
  const cities = useSelector((state) => state.Cities?.cities);
  const identity = useIdentityForm(logInUser);
  const [lookups, setLookups] = useState({
    defaultCompaniesList: [],
    defaultAccountManagerList: [],
    defaultVehiclesList: [],
    defaultGarageOptions: [],
    defaultAccountsList: [],
    defaultUsersList: [],
    parentUsersLimit: {},
    parentUnitsLimit: {},
    vehicleLimit: 0,
  });

  useEffect(() => {
    const load = async () => {
      try {
        const [companies, managers, vehicles, garages, accounts] = await Promise.all([
          listCompanies(),
          listAccountManagers(),
          listVehicles(logInUser.id),
          listGarages(logInUser.id),
          listAccountsForPicker(logInUser.accountId, logInUser),
        ]);
        let users = [];
        if (logInUser.userType === -1) {
          users = await listParentUsers(logInUser.accountId);
        }
        const [devicesCount, usersCount, vehiclesCount] = await Promise.all([
          countDevices(logInUser.id),
          countUsers(logInUser.id),
          countVehicles(logInUser.id),
        ]);
            const updatedCompanies =
  companies?.length > 0
    ? companies.map((item) => ({
        ...item,
        label:item?.companyName||item.name
      }))
    : [];
        setLookups({
          defaultCompaniesList: updatedCompanies,
          defaultAccountManagerList: managers,
          defaultVehiclesList: vehicles,
          defaultGarageOptions: garages,
          defaultAccountsList: accounts,
          defaultUsersList: users,
          parentUsersLimit: usersCount,
          parentUnitsLimit: devicesCount,
          vehicleLimit: vehiclesCount,
        });
      } catch (error) {
        toast.error(handleIdentityError(error, translate));
      }
    };
    if (logInUser?.id) load();
  }, [logInUser, translate]);

  const searchGarageList = async (inputValue) => {
    if (!inputValue) return [];
    return listGarages(logInUser.id, inputValue);
  };

  const formSubmit = async () => {
    const errors = computeCreateFieldErrors(
      identity.form,
      identity.accountsform,
      { managerAccountSelect: identity.managerAccountSelect },
    );
    if (Object.keys(errors).length) {
      identity.setFieldErrors(errors);
      toast.error(translate("emptyFields"));
      return;
    }
    identity.setFieldErrors({});
    try {
      const created = await createIdentity(
        identity.form,
        identity.accountsform,
        {
          managerAccountSelect: identity.managerAccountSelect,
          selectedVehicle: identity.selectedVehicle,
        },
      );
      // managedUserId permission call disabled
      // const createdUser = created?.user || created;
      // const createdAmUserId = getAmUserId({
      //   account: created?.account,
      //   user: createdUser,
      //   managerAccountSelect: identity.managerAccountSelect,
      //   form: identity.form,
      // });
      // if (createdUser?.id && createdAmUserId) {
      //   await assignPermission({
      //     userId: createdAmUserId,
      //     managedUserId: createdUser.id,
      //   });
      // }
      toast.success(translate("userIsCreated"));
      onCreated(created);
    } catch (error) {
      toast.error(handleIdentityError(error, translate));
    }
  };

  return (
    <AddAccountModal
      {...identity}
      {...lookups}
      addAccount
      function="addNew"
      roleTypes={roles?.filter((item) => item.id > 7)}
      cities={cities}
      handleChangeExpense={identity.handleChangeExpense}
      searchGarageList={searchGarageList}
      formSubmit={formSubmit}
      changeAttribute={identity.handleChange}
      handleChange={identity.handleChange}
      changeLimit={identity.changeLimit}
      modalControle={onCancel}
      userType={logInUser.userType}
      logInUser={logInUser}
      timeDateOnchange={identity.timeDateOnchange}
      generateToken={identity.generateToken}
      setNoToken={identity.setNoToken}
      setExpirationTime={identity.setExpirationTime}
      changeAttribute2={identity.changeAttribute2}
      changeAttribute2ForSP={identity.changeAttribute2}
      buttonText={translate("sharedCreate")}
      hasAccessOfUpdate={checkPrivileges("accountUpdate")}
      hasAccessOfDelete={checkPrivileges("accountDelete")}
      hasAccessOfCreate={checkPrivileges("accountCreate")}
      handleChangeAttributes={identity.handleChangeAttributes}
      timezone_handleChange={identity.timezone_handleChange}
      translate={translate}
      addUserFieldErrors={identity.addUserFieldErrors}
    />
  );
};

export default CreateUpdateForm;
